import { GoogleMapsClient } from './GoogleMapsClient.js';

export const clients = {
  GoogleMapsClient,
};
